import { useIsFocused } from "@react-navigation/native";
import { useEventOccurrenceQuery } from "@ticketingplatform/api/dist/event";
import { useEventOccurrenceContext } from "contexts/EventOccurrenceContext";

export const useEventOccurrence = (withTickets = false) => {
  const isFocused = useIsFocused();
  const { eventOccurrenceId } = useEventOccurrenceContext();
  const { data, loading } = useEventOccurrenceQuery(
    isFocused && eventOccurrenceId
      ? {
          variables: {
            id: eventOccurrenceId,
            eventInclude: true,
            venueInclude: true,
            ...(withTickets
              ? {
                  ticketPoolsInclude: true,
                  ticketPoolsTake: -1,
                }
              : {
                  ticketsAggregationInclude: true,
                }),
          },
        }
      : { skip: true }
  );
  const { eventOccurrence } = data || {};

  return {
    eventOccurrence,
    loading,
  };
};
